import moment from "moment";

type Insured = Record<string, unknown> & {
    exclusion?: boolean | number | null;
    fcAnexo?: Date | null;
};

/**
 * Si la fecha de inactividad (fcAnexo) es mayor a N días se filtra el asegurado
 */
export const filterInactiveInsureds = (insureds: Insured[] = []) => {
    return insureds.filter(insured => {
        if (insured.exclusion !== 1 && insured.exclusion !== true) return true;
        if (!insured.fcAnexo) return false;
        const inactiveDays = moment().diff(insured.fcAnexo, "days");
        return inactiveDays <= 30;
    });
};
